<template>
  <div class="top" :style="{'background-image': 'url('+ contentPageStyleVO.searchBgImageUrl +')'}">
    <div class="barnd_div" @click="goToBrandFun">
      <van-image class="barnd_img" :src="contentPageStyleVO.branchIconUrl ||barndIcon"></van-image>
      <p :style="{color: contentPageStyleVO.branchFontColor}">品牌</p>
    </div>
    <div class="serch_div" @click="goToSearchFun">
      <van-image :src="serchIcon" width="16" height="16"></van-image><span>搜索商品/品牌/小蜜蜂</span>
    </div>
    <div v-if="calendarStatus === 'false'" class="wechat_div" @click="goToBessWechat">
      <van-image class="wechat_img" :src="contentPageStyleVO.msgIconUrl || wechatIcon"></van-image>
      <p :style="{color: contentPageStyleVO.msgFontColor}">消息</p>
    </div>
    <div v-if="calendarStatus === 'true'" class="wechat_div calendar_div" @click="onCalendarShow">
      <van-image class="calendar_icon" :src="calendarIcon"></van-image>
    </div>
    <Calendar ref="calendar" v-if="popupShow" :popupShow.sync="popupShow" />
  </div>
</template>
<script>
import utils from '@/utils/common'
import Calendar from '@/components/home/calendar';
import http from "@/utils/axios";
export default {
  props: {
    contentPageId: {
      default: 0,
      type: Number
    },
    contentPageStyleVO: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data(){
    return{
      popupShow: false,
      barndIcon:require('@/assets/home/brandicon.png'),
      wechatIcon:require('@/assets/home/whaticon.png'),
      serchIcon:require('@/assets/home/serchicon.png'),
      calendarIcon:require('@/assets/home/calendar_icon@2x.png'),
      calendarStatus: ''
    }
  },
  components: { Calendar },
  mounted() {
    gio("track", "moduleExposure", {indexId_var: String(this.contentPageId), entryType_vara:'品牌', entryType_floor_var: String(0)});
    gio("track", "moduleExposure", {indexId_var: String(this.contentPageId), entryType_vara:'搜索', entryType_floor_var: String(0)});
    gio("track", "moduleExposure", {indexId_var: String(this.contentPageId), entryType_vara:'消息', entryType_floor_var: String(0)});
    this.getCalendarVisibleStatus()
  },
  methods:{
    onCalendarShow() {
      // this.$refs.calendar.changePopup()
      this.popupShow = !this.popupShow;
    },
    goToBrandFun(){
      gio("track", "flowLocationClick", {indexId_var: String(this.contentPageId), entryType_vara:'品牌', entryType_floor_var: String(0), sort_var: ''});
      utils.jumpToNewPage({
        url: window.location.origin + "/h5user/strollbrand",
        noTitle: "1",
      })
      utils.nativeMethod({tm:'4000101',tp:{module_evar: '品牌'}})
    },
    goToSearchFun(){
      gio("track", "flowLocationClick", {indexId_var: String(this.contentPageId), entryType_vara:'搜索', entryType_floor_var: String(0), sort_var: ''});
      this.$router.push({path:'/searchNew', query: {searchType: 'PRODUCT'}})
      utils.nativeMethod({tm:'4000101',tp:{module_evar: '搜索'}})
    },
    goToBessWechat(){
      gio("track", "flowLocationClick", {indexId_var: String(this.contentPageId), entryType_vara:'消息', entryType_floor_var: String(0), sort_var: ''});
      utils.goPageByName({id:'message',name:'消息'});
      utils.nativeMethod({tm:'4000101',tp:{module_evar: '消息'}})
    },
    getCalendarVisibleStatus() {
      http({
        url: '/order/admin/goods-activity-calendar/getCalendarConfig',
        method: 'GET'
      }).then(res => {
        this.calendarStatus = res.data.enableDisplay
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .top{
    height: 62px;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    font-size: 24px;
    padding: 15px 40px;
    color: #999;
    background-color: white;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .barnd_div, .wechat_div{
      font-size: 20px;

      .barnd_img, .wechat_img {
        width: 40px;
        height: 40px;
        vertical-align: bottom;
      }
    }
    .barnd_div {
      box-sizing: border-box;
      padding-right: 18px;
    }
    .wechat_div {
      box-sizing: border-box;
      padding-left: 18px;
    }
    .serch_div{
      display: flex;
      align-items: center;
      text-align: left;
      width: 506px;
      border-radius:38px;
      background-color: #F7F7F7;
      padding: 15px;
      flex: 1
    }
    .serch_div span{
      padding-left: 10px;
    }
    .calendar_icon {
      width: 66px;
      height: 66px;
    }
  }
</style>